import { useTranslation } from 'react-i18next'
import { useField, useFormikContext } from 'formik'
import InputField from 'components/atoms/fields/InputField'
import { ISessionBehaviour } from 'types'
import { FaCalendarAlt } from 'react-icons/fa'
import SliderField from 'components/atoms/fields/SliderField'

const SessionBehaviourItemList = ({ fieldProps, title="", disabled=false }) => {
  
  const { t } = useTranslation()
  const [field] = useField<ISessionBehaviour[]>(fieldProps.name)

  return (
    <>
      <div className='simple-table-wrapper'>
        <table className='checklist-table'>
          <tbody>
            {
              title && <tr>
                <th colSpan={4}>{<FaCalendarAlt />} {title}</th>
              </tr>
            }

            <tr className='checklist-table-subheading'>
              <th style={{width:'33%'}}>{t('common.students')}</th>
              <th style={{width:'34%'}}>{t('common.behavioural-incident-level')}</th>
              <th style={{width:'33%'}}>{t('common.notes')}</th>
            </tr>

              { 
                field.value.map((value: ISessionBehaviour, index: number) => ( 
                  <tr key={ value.student_id }>
                    <td>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <div>
                              <div className="avatar mini" style={{ backgroundImage: 'url('+value.student_avatar+')'}} />
                            </div>
                            <div style={{ paddingLeft: "5px" }}>
                                { value.student_name }<br/>
                            </div>
                          </div>
                    </td>
                    <td style={{ paddingRight: '40px' }}>
                        {<SliderField
                          valueSelector='incident_level'
                          fieldProps={{
                            label: t('common.incident-level'),
                            name: `${fieldProps.name}[${index}]`,
                          }}
                          disabled={disabled}
                          min={0}
                          max={100}
                          step={5}
                          
                        />}
                      </td>
                      <td>
                        {
                         <InputField
                            multiline
                            valueSelector='comment'
                            fieldProps={{
                               label: t('common.comment'),
                               name: `${fieldProps.name}[${index}]`,
                           }}
                          disabled={disabled}
                         />
                        }
                      </td>
                    </tr>
                  ))
              }

            </tbody>
          </table> 
        </div> 
    </>
  )

}
export default SessionBehaviourItemList